import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Matches from "../components/Matches";
import * as adminActions from "./../../../../../actions/admin.actions";
import * as commonActions from "./../../../../../actions/common.actions";
import { PROJECT_MATCHES_TABLE } from "./../../../../../actions/project.actions";

const subHeader = memberId => ({
  items: [
    {
      caption: "Profile",
      url: `/admin/member/approved/${memberId}/profile`
    },
    {
      caption: "Matches",
      url: `/admin/member/approved/${memberId}/matches`
    },
    {
      caption: "Pitches",
      url: `/admin/member/approved/${memberId}/pitches`
    },
    {
      caption: "SOWs",
      url: `/admin/member/approved/${memberId}/sows`
    }
  ],

  activeItem: 1
});

class AdminMemberMatchesContainer extends Component {
  constructor(props) {
    super(props);

    props.adminActions.getUser(this.props.match.params.memberId);

    this.setTableOverlay = this.setTableOverlay.bind(this);
    this.removeTableOverlay = this.removeTableOverlay.bind(this);
    this.reject = this.reject.bind(this);
    this.undoRejection = this.undoRejection.bind(this);
  }

  componentDidMount() {
    this.props.commonActions.setSubHeader(
      subHeader(this.props.match.params.memberId)
    );
  }

  componentWillUnmount() {
    this.props.commonActions.setSubHeader({});
  }

  setTableOverlay(position) {
    this.props.tableActions.setTableRowOverlayPosition({
      table: PROJECT_MATCHES_TABLE,
      overlayPosition: position
    });
  }

  removeTableOverlay() {
    this.props.tableActions.setTableRowOverlayPosition({
      table: PROJECT_MATCHES_TABLE,
      overlayPosition: null
    });
  }

  reject(matchId) {
    const payload = {
      match_id: matchId,
      declined: true
    };

    this.props.projectActions.declineMatch(payload);
  }

  undoRejection(matchId) {
    const payload = {
      match_id: matchId,
      declined: false
    };

    this.props.projectActions.declineMatch(payload);
  }

  render() {
    const matches = _.filter(this.props.admin.user.matches, match => {
      return match.potential !== true;
    });

    return <Matches matches={matches} />;
  }
}

const mapStateToProps = state => {
  return {
    admin: state.admin
  };
};

const mapDispatchToProps = dispatch => {
  return {
    adminActions: bindActionCreators(adminActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminMemberMatchesContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/memberApprovedProfile/matches/containers/AdminMemberMatchesContainer.js